<template>
    <b-container v-if="$can('view-products') || $can('view-all')" fluid>
        <b-row class="page-title">
            <b-container fluid>
                <b-row>
                    <b-col>
                        <h3>Products</h3>
                    </b-col>

                    <b-col class="buttons-create text-right">
                        <b-form-group>
                            <b-form-checkbox
                                id="checkbox-show-archived"
                                v-model="filters.selected.showArchived"
                                name="checkbox-show-archived"
                                value="1"
                                unchecked-value="0"
                                @input="filterSelect($event, 'showArchived')"
                            >
                                Archived
                            </b-form-checkbox>
                        </b-form-group>
                        <!-- <b-button variant="outline-primary" size="sm" @click="openModal('modal-common-bulk-edit')"
                            v-if="this.tables.products.selected.length">Update</b-button> -->
                        <b-button variant="outline-primary" size="sm" @click="recalc(); submittingRecalc = 1" v-if="this.tables.products.selected.length" :disabled="submittingRecalc == 1">
                            <span v-if="submittingRecalc">
                                <b-spinner small type="grow"></b-spinner>
                                Recalculating Items...
                            </span>
                            <span v-else>Recalc</span>
                        </b-button>
                        <b-button variant="outline-primary" size="sm"
                            @click="openModal('modal-inventory-products-create-product', '')">New</b-button>
                        <b-button variant="outline-primary" size="sm" @click="openModal('modal-common-import')"
                            v-if="$can('execute-import') || $can('view-all')">Import</b-button>
                        <b-button variant="outline-primary" size="sm" @click="openModal('modal-common-export-columns')">
                            Export</b-button>
                        <b-button variant="outline-primary" size="sm" @click="openModal('modal-common-adjust-columns')">
                            <i class="fas fa-columns"></i></b-button>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <div id="alert" v-if="tables.products.dataChanged">
                            <b-alert class="alert-warning-bar" show variant="warning">Table data updated. Click <b-link
                                    href="#" @click="tables.products.dataChanged = false; getProducts(1)"
                                    class="alert-link">UPDATE</b-link> to refresh.</b-alert>
                        </div>
                    </b-col>
                </b-row>
                <hr>
            </b-container>
        </b-row>

        <b-row>
            <b-container fluid>
                <b-row>
                    <b-col cols="2">
                        <b-form-group>
                            <b-input-group size="sm">
                                <b-form-input v-model="tables.products.filter" type="search" id="filterInput"
                                    placeholder="Type to Search" debounce="500"></b-form-input>
                                <b-input-group-append>
                                    <b-button variant="danger" v-if="tables.products.filter || hasFilters"
                                        @click="tables.products.filter = ''; tables.products.rowFilters = {}">X
                                    </b-button>
                                </b-input-group-append>
                            </b-input-group>
                        </b-form-group>
                    </b-col>

                    <b-col cols="3">
                        <b-form-row>
                            <b-col cols="6">
                                <b-form-datepicker v-model="tables.products.rowFilters.dateFrom" id="filter-dateFrom"
                                    size="sm"
                                    :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                                    locale="en" today-button close-button reset-button></b-form-datepicker>
                            </b-col>
                            <b-col cols="6">
                                <b-form-datepicker v-model="tables.products.rowFilters.dateTo" id="filter-dateTo"
                                    size="sm"
                                    :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                                    locale="en" today-button close-button reset-button></b-form-datepicker>
                            </b-col>
                        </b-form-row>
                    </b-col>

                    <b-col cols="2">
                        <treeselect name="productTypeSelect" class="product-type-select" clearable open-on-click
                            clear-on-select close-on-select disableBranchNodes placeholder="Filter by Type"
                            :options="tables.products.productTypeSelect" @input="filterSelect($event, 'productType')"
                            ref="selectProductType" />
                    </b-col>

                    <b-col cols="2">
                        <treeselect name="tagsSelect" class="tags-select" clearable searchable open-on-click
                            clear-on-select close-on-select disableBranchNodes placeholder="Filter by Tags"
                            :options="tables.products.tagsSelect" @input="filterSelect($event, 'tags')" multiple
                            ref="selectTags" />
                    </b-col>

                    <b-col cols="2">
                        <treeselect name="categoriesSelect" class="categories-select" clearable searchable open-on-click
                            clear-on-select close-on-select disableBranchNodes placeholder="Filter by Category"
                            :options="tables.products.categories" @input="filterSelect($event, 'category')"
                            ref="selectCategories" />
                    </b-col>

                    <b-col cols="1">
                        <b-form-group>
                            <b-form-select v-model="tables.products.perPage" id="perPageSelect" size="sm"
                                :options="tables.products.pageOptions"></b-form-select>
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row class="row-products-table">
                    <b-container fluid>
                        <b-table v-if="tables.products.ready" :key="tables.products.key" show-empty
                            class="products-table" responsive bordered striped hover no-border-collapse
                            sticky-header="calc(100vh - 250px)" head-variant="light" :items="filtered"
                            :fields="visibleFields" :sort-by="tables.products.sortBy"
                            :sort-desc="tables.products.sortDesc" :per-page="tables.products.perPage"
                            :current-page="tables.products.currentPage" :filter="tables.products.filter"
                            @filtered="onFiltered" :filter-included-fields="tables.products.filterIncludedFields"
                            :busy="tables.products.isBusy">
                            <template v-slot:table-busy>
                                <div class="text-center text-default my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                    <strong>Loading...</strong>
                                </div>
                            </template>

                            <template v-slot:top-row="{ fields }">
                                <td v-for="field in fields" :key="field.key">
                                    <b-form-select v-if="field.key == 'active' || field.key == 'archived'"
                                        v-model="tables.products.rowFilters[field.key]" class="mb-3">
                                        <b-form-select-option value=""></b-form-select-option>
                                        <b-form-select-option value="0">No</b-form-select-option>
                                        <b-form-select-option value="1">Yes</b-form-select-option>
                                    </b-form-select>

                                    <div class="filter-inline" v-else-if="field.key == 'qty_total'">
                                        <b-form-input v-model="tables.products.rowFilters.qtyFrom" type="search"
                                            id="filter-qtyFrom" placeholder="From" debounce="500"></b-form-input>
                                        <b-form-input v-model="tables.products.rowFilters.qtyTo" type="search"
                                            id="filter-qtyTo" placeholder="To" debounce="500"></b-form-input>
                                    </div>

                                    <div class="filter-inline" v-else-if="field.key == 'price'">
                                        <b-form-input v-model="tables.products.rowFilters.qtyPriceFrom" type="search"
                                            id="filter-qtyPriceFrom" placeholder="From" debounce="500" class="mr-1">
                                        </b-form-input>
                                        <b-form-input v-model="tables.products.rowFilters.qtyPriceTo" type="search"
                                            id="filter-qtyPriceTo" placeholder="To" debounce="500" class="mr-1">
                                        </b-form-input>
                                    </div>

                                    <div class="filter-inline" v-else-if="field.key == 'weighted_cost'">
                                        <b-form-input v-model="tables.products.rowFilters.qtyCostFrom" type="search"
                                            id="filter-qtyCostFrom" placeholder="From" debounce="500" class="mr-1">
                                        </b-form-input>
                                        <b-form-input v-model="tables.products.rowFilters.qtyCostTo" type="search"
                                            id="filter-qtyCostTo" placeholder="To" debounce="500" class="mr-1">
                                        </b-form-input>
                                    </div>

                                    <b-form-input v-else v-show="allowedField(field.key)"
                                        v-model="tables.products.rowFilters[field.key]" type="search"
                                        :id="'filter-' + field.key" debounce="500"></b-form-input>
                                </td>
                            </template>

                            <template v-slot:head(checkbox)="row">
                                <b-form-checkbox v-model="tables.products.allSelected" @change="toggleAll">
                                </b-form-checkbox>
                            </template>

                            <template v-slot:cell(checkbox)="row">
                                <b-form-checkbox :value="row.item.id" v-model="tables.products.selected"
                                    v-if="row.item.sku" />
                            </template>

                            <template v-slot:cell(thumb)="row">
                                <b-link v-if="row.item.item_image.length"
                                    @click="openModal('modal-inventory-products-show-image', getImageUrl(row.item.sku, 'MEDIUM', row.item.item_image[0].sequence, row.item.item_image[0].extension) + '?rnd=' + tables.products.cacheKey)">
                                    <b-img-lazy v-if="row.item.item_image.length" class="products-thumbs"
                                        :src="getImageUrl(row.item.sku, 'MEDIUM', row.item.item_image[0].sequence, row.item.item_image[0].extension) + '?rnd=' + tables.products.cacheKey">
                                    </b-img-lazy>
                                </b-link>
                            </template>

                            <template v-slot:cell(sku)="row">
                                <div class="text-nowrap">
                                    <b-button variant="link" size="sm"
                                        @click="openModal('modal-common-product-preview', row.item.sku)"><i
                                            class="far fa-sm fa-eye"></i></b-button>
                                    <b-link :ref="'productsTableRow' + row.item.id"
                                        @click="saveState('productsTableRow' + row.item.id)"
                                        :to="{name: 'ProductDetail', params: { sku: row.item.sku } }">{{ row.item.sku }}
                                    </b-link>
                                </div>
                            </template>

                            <template v-slot:cell(category)="row">
                                <span v-if="row.item.category">{{ row.item.category.name }}</span>
                                <span v-else></span>
                            </template>

                            <template v-slot:cell(vendor)="row">
                                <span v-if="row.item.vendor && ($can('view-all') || $can('view-product-vendor'))">{{
                                    row.item.vendor.name }}</span>
                                <span v-else></span>
                            </template>

                            <template v-slot:cell(weighted_cost)="row">
                                <span v-if="$can('view-all') || $can('view-product-cost')">$ {{
                                    numberWithCommas(row.item.weighted_cost) || '0.00' }}</span>
                            </template>

                            <template v-slot:cell(mpn)="row">
                                <span v-if="row.item.mpn && ($can('view-all') || $can('view-product-mpn'))">{{
                                    row.item.mpn }}</span>
                                <span v-else></span>
                            </template>

                            <template v-slot:cell(active)="row">
                                <span v-if="row.item.active">Yes</span>
                                <span v-else>No</span>
                            </template>

                            <template v-slot:cell(qty_available)="row">
                                {{ row.item.qty_available || 0 }}
                            </template>

                            <template v-slot:cell(tags)="row">
                                    <span v-if="row.item.tags">
                                        <b-badge v-for="(tag, index) in row.item.tags" :key="index" pill
                                            variant="secondary" class="tag-badges">{{ tag.tag.name }}</b-badge>
                                    </span>
                                    <span v-else></span>
                                </template>

                            <!-- <template v-slot:cell(qty_on_order)="row">
                                <span v-if="row.item.open_orders_count">{{ calculateOpenOrders(row.item.sales_order_lines) }}</span>
                                <span v-else>0</span>
                            </template>

                            <template v-slot:cell(open_orders_count)="row">
                                <b-link
                                    @click="openModal('modal-inventory-products-show-open-orders', row.item.sales_order_lines)">
                                        {{ row.item.open_orders_count || 0 }}
                                </b-link>
                            </template> -->

                            <template v-slot:cell(price)="row">
                                <span>$ {{ numberWithCommas(row.item.price) || '0.00' }}</span>
                            </template>

                            <template v-slot:cell(created_at)="row">
                                <span>{{ row.item.created_at | moment('MM-DD-YYYY')}}</span>
                            </template>

                            <template v-slot:cell(archived)="row">
                                <span v-if="row.item.archived">Yes</span>
                                <span v-else>No</span>
                            </template>

                            <!-- <template v-slot:cell(sales_order_lines)="row">
                                <b-link @click="openModal('modal-inventory-products-show-open-orders', row.item.sales_order_lines)">{{ calculateOpenOrders(row.item.sales_order_lines) || '0'}}</b-link>
                            </template> -->

                            <template v-slot:cell(actions)="row">
                                <b-container class="actions-icons" fluid>
                                    <b-row>
                                        <b-col>
                                            <b-link :to="{name: 'ProductDetail', params: { sku: row.item.sku } }"><i
                                                    class="fas fa-info"></i></b-link>
                                        </b-col>
                                        <b-col>
                                            <b-link
                                                @click="openModal('modal-inventory-products-edit-product', row.item.id)">
                                                <i class="fas fa-edit"></i>
                                            </b-link>
                                        </b-col>
                                        <b-col>
                                            <b-link @click="duplicateItem(row.item.id)"><i class="far fa-clone"></i>
                                            </b-link>
                                        </b-col>
                                        <b-col v-if="$can('view-all')">
                                            <b-link @click="deleteConfirm('Product', row.item.sku, row.item.id)"
                                                class="icon-danger"><i class="fas fa-trash-alt"></i></b-link>
                                        </b-col>
                                    </b-row>
                                </b-container>
                            </template>
                        </b-table>
                    </b-container>
                </b-row>

                <b-row>
                    <b-col cols="6">
                        {{ pageTotals }}
                    </b-col>

                    <b-col cols="6" class="my-1">
                        <b-pagination v-model="tables.products.currentPage" :total-rows="tables.products.totalRows"
                            :per-page="tables.products.perPage" align="fill" size="sm" class="my-0"></b-pagination>
                    </b-col>
                </b-row>

                <modal-create-product v-if="modals['modal-inventory-products-create-product'].active"
                    :categories="tables.products.categories" :vendors="tables.products.vendors"
                    :tags="tables.products.tags" :attributes="tables.products.attributes"
                    :attributesFilters="tables.products.attributesFilters"
                    :attributesOptions="tables.products.attributesOptions" />

                <modal-edit-product v-if="modals['modal-inventory-products-edit-product'].active"
                    :row="modals['modal-inventory-products-edit-product'].row" :categories="tables.products.categories"
                    :vendors="tables.products.vendors" :tags="tables.products.tags"
                    :attributes="tables.products.attributes" :attributesFilters="tables.products.attributesFilters"
                    :attributesOptions="tables.products.attributesOptions" />

                <modal-show-image v-if="modals['modal-inventory-products-show-image'].active"
                    :url="modals['modal-inventory-products-show-image'].url" />

                <modal-show-open-orders v-if="modals['modal-inventory-products-show-open-orders'].active"
                    :lines="modals['modal-inventory-products-show-open-orders'].lines" />

                <modal-adjust-columns v-if="modals['modal-common-adjust-columns'].active"
                    :fields="modals['modal-common-adjust-columns'].fields" @saveColSaves="saveColSaves" />

                <modal-export-columns v-if="modals['modal-common-export-columns'].active"
                    :fields="modals['modal-common-export-columns'].fields"
                    :ignores="modals['modal-common-export-columns'].ignores" @exportExcel="exportExcel" />

                <modal-product-preview v-if="modals['modal-common-product-preview'].active"
                    :sku="modals['modal-common-product-preview'].sku" />

                <modal-bulk-edit v-if="modals['modal-common-bulk-edit'].active"
                    :fields="modals['modal-common-bulk-edit'].fields" :table="'items'" />

                <modal-import v-if="modals['modal-common-import'].active" :url="modals['modal-common-import'].url" />
            </b-container>
        </b-row>
    </b-container>
</template>

<script>
    import Treeselect from '@riophae/vue-treeselect'
    import VueTagsInput from '@johmun/vue-tags-input'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import { VueAutosuggest } from 'vue-autosuggest'
    import ModalCreateProduct from './modals/Create'
    import ModalEditProduct from './modals/Edit'
    import ModalShowImage from './modals/ShowImage'
    import ModalShowOpenOrders from './modals/ShowOpenOrders'
    import ModalAdjustColumns from '../../common/modals/AdjustColumns'
    import ModalExportColumns from '../../common/modals/ExportColumns'
    import ModalBulkEdit from '../../common/modals/BulkEdit'
    import ModalImport from '../../common/modals/Import'
    import ModalProductPreview from '../../common/modals/ProductPreview'
    import { mapGetters } from 'vuex'
    export default {
        name: 'Products',

        metaInfo() {
            return {
                title: 'Products',
            }
        },

        components: {
            Treeselect,
            VueTagsInput,
            VueAutosuggest,
            'modal-create-product': ModalCreateProduct,
            'modal-edit-product': ModalEditProduct,
            'modal-show-image': ModalShowImage,
            'modal-show-open-orders': ModalShowOpenOrders,
            'modal-adjust-columns': ModalAdjustColumns,
            'modal-export-columns': ModalExportColumns,
            'modal-bulk-edit': ModalBulkEdit,
            'modal-import': ModalImport,
            'modal-product-preview': ModalProductPreview
        },
        data() {
            return {
                modals: {
                    'modal-inventory-products-create-product': {
                        active: 0
                    },

                    'modal-inventory-products-edit-product': {
                        active: 0,
                        row: null
                    },

                    'modal-inventory-products-show-image': {
                        active: 0,
                        url: ''
                    },

                    'modal-inventory-products-show-open-orders': {
                        active: 0,
                        lines: []
                    },

                    'modal-common-adjust-columns': {
                        active: 0,
                        fields: []
                    },

                    'modal-common-export-columns': {
                        active: 0,
                        fields: [],
                        ignores: ['thumb', 'open_estimates', 'open_po', 'actions', 'checkbox']
                    },

                    'modal-common-product-preview': {
                        active: 0
                    },

                    'modal-common-bulk-edit': {
                        active: 0,
                        fields: [],
                        ignores: ['thumb', 'actions', 'checkbox']
                    },

                    'modal-common-import': {
                        active: 0,
                        url: 'api/inventory/products/import'
                    }
                },

                tables: {
                    products: {
                        dataChanged: false,
                        selected: [],
                        allSelected: false,
                        filteredItems: [],
                        rowFilters: {

                        },
                        isBusy: false,
                        totalRows: 1,
                        currentPage: 1,
                        perPage: 20,
                        pageOptions: [20, 50, 100, 500, 1000],
                        sortBy: 'created_at',
                        sortDesc: true,
                        // sortDirection: 'asc',
                        filter: null,
                        // filterCat: '',
                        filterIncludedFields: [
                            'sku',
                            'name',
                            'checkbox'
                        ],
                        key: 1,
                        userfields: [],
                        fields: [
                            {
                                key: 'checkbox',
                                label: '',
                                visible: 1
                            },
                            {
                                key: 'thumb',
                                label: '',
                                visible: 1
                            },
                            {
                                key: 'sku',
                                label: 'SKU',
                                sortable: true,
                                visible: 1
                            },
                            {
                                key: 'name',
                                label: 'Name',
                                sortable: true,
                                visible: 1
                            },
                            {
                                key: 'qty_total',
                                label: 'QTY',
                                sortable: true,
                                visible: 1
                            },
                            {
                                key: 'qty_wh_a',
                                label: 'BSG',
                                sortable: true,
                                thStyle: { 'white-space': 'nowrap' },
                                visible: 1
                            },
                            {
                                key: 'qty_wh_b',
                                label: 'Road',
                                sortable: true,
                                thStyle: { 'white-space': 'nowrap' },
                                visible: 1
                            },
                            {
                                key: 'qty_available',
                                label: 'Avail',
                                sortable: true,
                                thStyle: { 'white-space': 'nowrap' },
                                visible: 1
                            },
                            {
                                key: 'qty_on_order',
                                label: 'QOO',
                                sortable: true,
                                thStyle: { 'white-space': 'nowrap' },
                                visible: 1
                            },
                            {
                                key: 'open_orders_count',
                                label: 'Open',
                                sortable: true,
                                thStyle: { 'white-space': 'nowrap' },
                                visible: 1
                            },
                            {
                                key: 'price',
                                label: 'Price',
                                sortable: true,
                                visible: 1
                            },
                            {
                                key: 'weighted_cost',
                                label: 'WAC',
                                sortable: true,
                                visible: 1
                            },
                            {
                                key: 'vendor',
                                label: 'Vendor',
                                sortable: true,
                                visible: 1
                            },
                            {
                                key: 'category',
                                label: 'Category',
                                sortable: true,
                                visible: 1
                            },
                            {
                                key: 'mpn',
                                label: 'MPN',
                                sortable: true,
                                visible: 1
                            },
                            {
                                key: 'created_at',
                                label: 'Date Added',
                                sortable: true,
                                thStyle: { 'white-space': 'nowrap' },
                                visible: 1
                            },
                            {
                                key: 'open_estimates',
                                label: 'Est.',
                                sortable: true,
                                thStyle: { 'white-space': 'nowrap' },
                                visible: 1
                            },
                            {
                                key: 'open_po',
                                label: 'PO\'s',
                                sortable: true,
                                thStyle: { 'white-space': 'nowrap' },
                                visible: 1
                            },
                            {
                                key: 'tags',
                                label: 'Tags',
                                sortable: true,
                                visible: 1
                            },
                            {
                                key: 'active',
                                label: 'Visible',
                                sortable: true,
                                visible: 1
                            },
                            {
                                key: 'archived',
                                label: 'Archived',
                                sortable: true,
                                visible: 1
                            },
                            {
                                key: 'actions',
                                label: '',
                                thClass: 'products-table-style-actions',
                                visible: 1
                            }
                        ],

                        items: [],
                        categories: [],
                        tags: [],
                        tagsSelect: [],
                        productTypeSelect: [],
                        vendors: [],
                        attributes: [],
                        attributesOptions: [],
                        attributesFilters: [],
                        vendors: [],
                        cacheKey: 0,
                        ready: 0
                    },
                },

                filters: {
                    selected: {
                        tags: [],
                        category: '',
                        productType: '',
                        showArchived: 0
                    }
                },

                exports: {
                    cols: []
                },

                submittingRecalc: 0
            }
        },
        methods: {
            toggleAll() {
                this.tables.products.selected = []

                if (this.tables.products.allSelected) {
                    for (let item in this.filtered) {
                        this.tables.products.selected.push(this.filtered[item].id.toString())
                    }
                }
            },

            select: function() {
                this.tables.products.allSelected = false
            },

            // findLastCost(arr) {
            //     let lastCost = 0
            //     arr.forEach((row, idx, array) => {
            //         if (row.bill.status == 'Received') {
            //             if (!lastCost) {
            //                 lastCost = row.price
            //             }
            //         }
            //     })

            //     return lastCost
            // },

            saveState(name) {
                let page = this.tables.products.currentPage
                let filter = this.tables.products.filter
                let perPage = this.tables.products.perPage
                let rowFilters = this.tables.products.rowFilters
                this.setRememberProduct({name: name, page: page, filter: filter, perPage: perPage, rowFilters: rowFilters })
            },

            setLastState() {
                this.$nextTick(() => {
                    if (this.rememberedProduct.name && this.rememberedProduct.page) {
                        this.tables.products.currentPage = this.rememberedProduct.page
                        this.$nextTick(() => {
                            this.$refs[this.rememberedProduct.name].$el.scrollIntoView()
                        })
                    }
                })
            },

            allowedField(key) {
                let ignores = ['thumb', 'sku', 'name', 'category', 'qty_wh_a', 'qty_wh_b', 'qty_available', 'qty_on_order', 'vendor', 'mpn', 'created_at', 'actions']

                if (!ignores.includes(key)) {
                    return true
                }
            },

            // exportExcel() {
            //     let url = 'api/inventory/products/exportexcel'
            //     axios.post(url, {
            //         rows: this.filtered
            //     },
            //     {
            //         responseType: 'blob'
            //     })
            //     .then((res) => {
            //         this.forceFileDownload(res)
            //     }, () => {
            //         this.has_error = true
            //     })
            // },

            exportExcel(cols, keys) {
                let url = 'api/exports/generateexport'
                axios.post(url, {
                    rows: this.objFilter(this.tables.products.filteredItems, keys),
                    table: 'items',
                    cols: cols,
                    keys: keys
                },
                {
                    responseType: 'blob'
                })
                .then((res) => {
                    this.forceFileDownload(res)
                }, () => {
                    this.has_error = true
                })
            },

            duplicateItem(itemId) {
                let url = 'api/inventory/products/duplicate'
                axios.post(url, {
                    itemId: itemId
                })
                .then((res) => {
                    this.getProducts(1)
                }, () => {
                    this.has_error = true
                })
            },

            forceFileDownload(response){
                const url = window.URL.createObjectURL(new Blob([response.data]))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', 'Products_Export_File_' + +new Date() + '.xlsx') //or any other extension
                document.body.appendChild(link)
                link.click()

                this.showAlertBox('success', 'File Generated', 'Products export file generated successfully!')
            },

            recalc() {
                let url = 'api/inventory/products/recalculatebatch'
                axios.post(url, {
                    ids: this.tables.products.selected
                })
                    .then((res) => {
                        this.tables.products.selected = []
                        this.getProducts(1)
                        this.showAlertBox('success', 'Item(s) Recalculated', 'Items(s) recalculated successfully!')
                        this.submittingRecalc = 0
                    }, () => {
                        this.has_error = true
                    })
            },

            // createRow(row) {
            //     this.tables.products.items.push(row)
            //     this.tables.products.key++
            // },

            updateRow(row) {
            //     let index = this.findIndex(this.tables.products.items, 'id', row.id)
            //     this.tables.products.items[index] = row
                this.tables.products.key++
                this.tables.products.cacheKey = this.$moment().unix()
            },

            openModal(modalName, row) {
                switch (modalName) {
                    case 'modal-inventory-products-create-product':
                        this.modals[modalName].active = 1

                        break
                    case 'modal-inventory-products-edit-product':
                        this.modals[modalName].active = 1
                        this.modals[modalName].row = row

                        break
                    case 'modal-inventory-products-show-image':
                        this.modals[modalName].active = 1
                        this.modals[modalName].url = row

                        break
                    case 'modal-inventory-products-show-open-orders':
                        this.modals[modalName].active = 1
                        this.modals[modalName].lines = row

                        break
                    case 'modal-common-adjust-columns':
                        this.modals[modalName].active = 1

                        this.modals[modalName].fields = this.tables.products.userFields ? JSON.parse(JSON.stringify(this.tables.products.userFields)) : JSON.parse(JSON.stringify(this.tables.products.fields))

                        break
                    case 'modal-common-export-columns':
                        this.modals[modalName].active = 1

                        this.modals[modalName].fields = JSON.parse(JSON.stringify(this.tables.products.fields.filter(e => !this.modals[modalName].ignores.includes(e.key))))

                        break
                    case 'modal-common-product-preview':
                        this.modals['modal-common-product-preview'].sku = row
                        this.modals['modal-common-product-preview'].active = 1

                        break
                    case 'modal-common-bulk-edit':
                        this.modals[modalName].active = 1

                        this.modals[modalName].fields = JSON.parse(JSON.stringify(this.tables.products.fields.filter(e => !this.modals[modalName].ignores.includes(e.key))))

                        break

                    case 'modal-common-import':
                        this.modals[modalName].active = 1

                        break
                }

                this.$nextTick(() => {
                    this.$bvModal.show(modalName)
                })
            },

            toggleBusy() {
                this.tables.products.isBusy = !this.tables.products.isBusy
            },

            calculateOpenOrders(lines) {
                let count = Number(0)
                lines.forEach((row, idx, array) => {
                    if (row.sale_order.status == 'Confirmed' || row.sale_order.status == 'Dispatched') {
                        count+= +row.quantity
                    }
                })

                return count
            },

            getProducts(silent) {
                if (!silent) {
                    this.tables.products.ready = 0

                    this.tables.products.filter = this.rememberedProduct.filter
                    this.tables.products.perPage = this.rememberedProduct.perPage
                    this.tables.products.rowFilters = this.rememberedProduct.rowFilters

                    this.toggleBusy()
                }

                let url = 'api/inventory/products/getproducts'
                axios.post(url, {
                    filters: this.filters.selected
                })
                .then((res) => {
                    this.tables.products.items = res.data.items

                    // if (!silent) {
                        // if (!this.tables.products.filteredItems.length) {
                            this.tables.products.filteredItems = res.data.items
                        // }
                        this.tables.products.totalRows = this.tables.products.items.length
                    if (!silent) {
                        this.tables.products.ready = 1
                        this.toggleBusy()

                        this.setLastState()
                    }
                }, () => {
                    this.has_error = true
                })
            },

            filterSelect(name, area) {
                this.filters.selected[area] = name
                this.getProducts(1)
            },

            findCategoryName(id) {
                let index = this.findIndex(this.tables.products.categories, 'id', id)
                return this.tables.products.categories[index].label
            },

            getCategories() {
                let url = 'api/inventory/products/getcategoriesfilter'
                axios.get(url, {})
                .then((res) => {
                    this.tables.products.categories = res.data.categories
                }, () => {
                    this.has_error = true
                })
            },

            getTags() {
                let url = 'api/inventory/products/gettagsfilter'
                axios.get(url, {})
                .then((res) => {
                    this.tables.products.tags = res.data.tags
                    this.tables.products.tagsSelect = res.data.tagsSelect
                }, () => {
                    this.has_error = true
                })
            },

            getVendors() {
                let url = 'api/inventory/products/getvendorsfilter'
                axios.get(url, {})
                .then((res) => {
                    this.tables.products.vendors = res.data.vendors
                }, () => {
                    this.has_error = true
                })
            },

            getAttributes() {
                let url = 'api/inventory/products/getattributesfilter'
                axios.get(url, {})
                .then((res) => {
                    this.tables.products.attributes = res.data.attributes
                    this.tables.products.attributesFilters = res.data.attributesFilters
                    this.tables.products.attributesOptions = res.data.attributesOptions
                }, () => {
                    this.has_error = true
                })
            },

            onFiltered(filteredItems) {
                this.tables.products.totalRows = filteredItems.length
                this.tables.products.currentPage = 1
                this.tables.products.filteredItems = filteredItems
            },

            deleteConfirm(area, name, id) {
                // let boxConfirmModal = this.modals['modal-delete'].box

                this.$bvModal.msgBoxConfirm('Please confirm that you want to delete: ' + name, {
                        title: 'Delete: ' + name,
                        size: 'sm',
                        buttonSize: 'sm',
                        okVariant: 'danger',
                        okTitle: 'Confirm',
                        cancelTitle: 'Cancel',
                        footerClass: 'p-2',
                        hideHeaderClose: false,
                        centered: true
                })
                .then(value => {
                    if (value) {
                        this.deleteProduct(id)
                    }
                })
                .catch(err => {
                    // An error occurred
                })
            },

            deleteProduct(id) {
                let url = 'api/inventory/products/delete/' + id
                axios.get(url, {})
                .then((res) => {
                    if (res.data.status == 'success') {
                        let index = this.findIndex(this.tables.products.items, 'id', id)
                        this.tables.products.items.splice(index, 1)
                    }
                }, () => {
                    this.has_error = true
                })
            },

            getValidationState({ dirty, validated, valid = null }) {
                return dirty || validated ? valid : null
            },

            getColSaves() {
                let url = 'api/remembertable/getcolsaves/products'
                axios.get(url, {})
                .then((res) => {
                    if (res.data.status == 'success') {
                        if (res.data.colSaves) {
                            if (res.data.colSaves.column_array.length == this.tables.products.fields.length) {
                                this.tables.products.userFields = res.data.colSaves.column_array
                            }
                        }

                        this.getProducts()
                    }
                }, () => {
                    this.has_error = true
                })
            },

            saveColSaves(fields) {
                this.tables.products.userFields = fields
                let url = 'api/remembertable/savecolsaves'
                axios.post(url, {
                    area: 'products',
                    fields: fields.map(e => ({key:e.key, visible:parseInt(e.visible), label:e.label}))
                })
                .then((res) => {
                    this.forceRerender()
                }, () => {
                    this.has_error = true
                })
            },

            forceRerender() {
                this.tables.products.ready = 0
                let tempFields = this.tables.products.fields
                this.tables.products.fields = []
                this.$nextTick(() => {
                    this.tables.products.fields = tempFields
                    this.tables.products.ready = 1
                })
            }
        },

        computed: {
            ...mapGetters({
                user: 'auth/user'
            }),

            // sortOptions() {
            //     // Create an options list from our fields
            //     return this.tables.products.fields
            //         .filter(f => f.sortable)
            //         .map(f => {
            //             return { text: f.label, value: f.key }
            //         })
            // },

            pageTotals() {
                let totalRows = this.tables.products.totalRows
                let currentPage = this.tables.products.currentPage
                let perPage = this.tables.products.perPage

                let from
                let to

                if (perPage > totalRows) {
                    from = 1
                    to = totalRows
                } else {
                    to = perPage * currentPage
                    from = to - perPage + 1
                }

                return 'Showing ' + from + ' to ' + to + ' of ' + this.tables.products.totalRows + ' rows'
            },

            hasFilters() {
                let hasFilters = false
                let rowFilters = this.tables.products.rowFilters
                Object.keys(rowFilters).forEach(key => {
                    if (rowFilters[key].length) {
                        hasFilters = true
                    }
                })

                return hasFilters
            },

            filtered() {
                var items = this.tables.products.items
                var rowFilters = this.tables.products.rowFilters

                if (items && this.hasFilters) {
                    const filtered = items.filter(item => {
                        return Object.keys(rowFilters).every(key => {
                            if (rowFilters[key].length) {
                                let filterVal = rowFilters[key]

                                if (key == 'active') {
                                    return String(item[key]) == filterVal
                                } else if (key == 'qtyFrom') {
                                    return item['qty_total'] >= Number(filterVal)
                                } else if (key == 'qtyTo') {
                                    return item['qty_total'] <= Number(filterVal)
                                } else if (key == 'qtyPriceFrom') {
                                    return item['price'] >= Number(filterVal)
                                } else if (key == 'qtyPriceTo') {
                                    return item['price'] <= Number(filterVal)
                                } else if (key == 'qtyCostFrom') {
                                    return item['weighted_cost'] >= Number(filterVal)
                                } else if (key == 'qtyCostTo') {
                                    return item['cost'] <= Number(filterVal)
                                } else if (key == 'dateFrom') {
                                    return item['created_at'] >= filterVal
                                } else if (key == 'dateTo') {
                                    return item['created_at'] <= filterVal
                                // } else if (key == 'vendor') {
                                //     let vendor = Object.hasOwn(item, 'vendor') ? item[key] : null;
                                //     return vendor ? String(vendor.name).toLowerCase().includes(filterVal.toLowerCase()) : false
                                } else {
                                    return String(item[key]).toLowerCase().includes(rowFilters[key].toLowerCase())
                                }
                            } else {
                                return true
                            }
                        })
                    })

                    this.tables.products.totalRows = filtered.length
                    return filtered
                } else {
                    this.tables.products.totalRows = items.length
                    return items
                }
            },

            visibleFields() {
                let userFields = this.tables.products.userFields
                if (userFields) {
                    let fields = this.tables.products.fields

                    return fields.filter(field => {
                        let index = this.findIndex(userFields, 'key', field.key)
                        if (userFields[index].visible) {
                            return true
                        }
                    })
                } else {
                    return this.tables.products.fields
                }
            }
        },

        mounted() {
            this.cacheKey = this.$moment().unix()
            this.tables.products.productTypeSelect.push({id: 'Simple', label: 'Simple'}, {id: 'Bundle', label: 'Bundle'})
            this.getColSaves()
            this.getCategories()
            this.getTags()
            this.getVendors()
            this.getAttributes()

            this.$root.$on('bv::modal::hidden', (bvEvent, modalId) => {
                switch (modalId) {
                    case 'modal-inventory-products-create-product':
                        this.modals['modal-inventory-products-create-product'].active = 0

                        break
                    case 'modal-inventory-products-edit-product':
                        this.modals['modal-inventory-products-edit-product'].active = 0

                        break
                    case 'modal-inventory-products-show-image':
                        this.modals['modal-inventory-products-show-image'].active = 0
                        this.modals['modal-inventory-products-show-image'].url = ''

                        break
                    case 'modal-inventory-products-show-open-orders':
                        this.modals['modal-inventory-products-show-open-orders'].active = 0
                        this.modals['modal-inventory-products-show-open-orders'].lines = []

                        break
                    case 'modal-common-adjust-columns':
                        this.modals['modal-common-adjust-columns'].active = 0
                        this.modals['modal-common-adjust-columns'].fields = []

                        break
                    case 'modal-common-export-columns':
                        this.modals['modal-common-export-columns'].active = 0
                        this.modals['modal-common-export-columns'].fields = []

                        break
                    case 'modal-common-import':
                        this.modals['modal-common-import'].active = 0

                        break
                    case 'modal-common-product-preview':
                        this.modals['modal-common-product-preview'].active = 0

                        break
                    default:

                }
            })

            // pusher
            Echo.channel('table-item-updated')
                .listen('TableItemUpdated', (e) => {
                    // if (this.user.id != e.user.id) {
                        // this.getProducts(1)
                        this.tables.products.dataChanged = true
                    // }
            })
        }
  }
</script>
<style lang="scss">
    .tags-select .vue-treeselect__control, .categories-select .vue-treeselect__control {
        font-size: 0.875rem !important;
    }

    .products-table {
        // height: 600px;
        height: 75vh;
        font-size: 9pt;

        .products-thumbs {
            width: 50px;
            max-height: 50px;
        }

        .products-table-style-actions {
            width: 120px;

            .actions-icons {
                text-align: center;
            }
        }

        .filter-inline {
            // display: flex;
            input {
                min-width: 35px;
                width: 100%;
                padding: 2px;
                font-size: 9pt;
            }
        }

        .b-table-top-row #filter-checkbox {
            display: none;
        }
    }
</style>
